import React from 'react';
import { withRouter } from 'react-router';
import { connect } from "react-redux";
import { withApollo } from 'react-apollo';

import TopPanel from '../../../layouts/TopPanel/TopPanel';

import LayoutBuilder from '../../../ui/form/LayoutFormBuilder';
import TraductionSelect from '../../../layouts/TopPanel/TraductionSelect';
import collectionEdit from './config/collectionEdit.config';
import { START_LOADING, STOP_LOADING, SNACK } from '../../../../js/constants/action-types';
import { ALERT_ERROR, ALERT_SUCCESS } from '../../../../js/constants/alert-types';
import colors from '../../../../config/theme/colors';
import { eventService } from '../../../../js/services/event.service';
import request from '../../../../js/utils/fetch';

import { ROUTE_HOME } from '../../../../js/constants/route-names';
import { PRODUCTS, PRODUCTS_PRODUCTS, VIEW, CREATE, IMPORT } from '../../../../js/constants/constant-rights';

import { prepareAttributeValues, saveElement, updateElement, getElements } from '../../../../js/utils/functions';
import Listing from '../../../layouts/Listing/Listing';
import { listSettings, listMappers, perPageOptions } from './config/listCollections.config';
import * as formHelper from '../../../../js/helpers/form'
import { makeUnique, searchItem } from '../../../../js/helpers/search'
import { DELETE_SELECTION } from '../../../../queries/selections';
import { Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '../../../ui/button/Button';
import { withTranslation } from 'react-i18next'
import { checkRouting } from '../../../../js/utils/checkRouting';



class ListCollections extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openForm: false,
            editForm: 'add',
            currentLang: props.locales[0].node.code,
            errors: {},
            seeErrors: false,
            ready: false,
        };
    }

    handleLang = (event) => {
        this.setState({
            currentLang: event.target.value,
        }, () => {
            eventService.fire();
        });
    };

    // handleChangeCompanies = async(e)=>{
    //     let idList = await searchItem(e,'company','/api/companies/',{attributes:null},{delay:100})
    //     this.setState({
    //         activeSearchCompanies : idList,
    //     })
    // }

    handleToggleDrawer = (stateDrawer, reset = false) => {
        this.setState({
            [stateDrawer]: !this.state[stateDrawer]
        });
        if (reset) {
            this.resetState()
        }
    };


    handleFormError = (stateName, error) => {
        let errors = this.state.errors;
        errors[stateName] = error;
        this.setState({ errors });
    };

    handleNextStep = () => {
        let result = formHelper.handleStep('next', this.state.errors);
        this.setState({
            seeErrors: !result
        })
        return result;
    }

    handleBackStep = () => {
        this.setState({ errors: {} });
    }


    handleMediaPicker = (selected, stateName, translated) => {
        this.handleInput(stateName, selected, null, translated);
    }

    handleInput = (stateName, evt, custom, translated) => {
        let value = formHelper.setValue(this.state, stateName, evt, custom, translated);
        this.setState({ ...value })
    }

    resetState = () => {
        this.setState({
            collectionIdentifier: null,
        })
    }

    handlerCollectionMutation = async () => {
        this.props.startLoading();
        let variables = null;
        switch (this.state.editForm) {
            case 'add':

                variables = {
                    identifier: this.state.collectionIdentifier,
                }
                let newCollection = await saveElement('selection', variables, { enableLoad: false })
                this.props.snack(ALERT_SUCCESS, 'Collection ajoutée avec succès');
                this.handleToggleDrawer('openForm', true);
                this.reloadCollections();
                this.props.stopLoading();
                break;

            case 'edit':

                variables = {
                    id: this.state.currentCollectionId,
                    identifier: this.state.collectionIdentifier,
                }
                let getResult = await updateElement(this.state, 'selection', variables, null, { enableLoad: false })
                if (getResult) {
                    this.props.snack(ALERT_SUCCESS, 'Collection modifiée avec succès');
                    this.handleToggleDrawer('openForm', true);
                    this.props.stopLoading();
                    this.reloadCollections();
                }

                break;
            default:
                return null;
        }
    }

    handleToggleDialog = () => {
        this.setState({
            openDialog: !this.state.openDialog
        });
    };

    deleteMutation = () => {
        this.props.startLoading();
        this.props.client.mutate({
            mutation: DELETE_SELECTION,
            variables: { id: this.state.currentCollectionId }
        }).then(result => {
            this.props.stopLoading();
            this.props.snack(ALERT_SUCCESS, 'Collection supprimé avec succès');
            this.reloadCollections();
            this.handleToggleDialog();
            this.handleToggleDrawer('openForm', true);
        }).catch(error => {
            this.props.stopLoading();
            this.props.snack(ALERT_ERROR, `Impossible de supprimer la collection`);
            this.reloadCollections();
            this.handleToggleDialog();
            this.handleToggleDrawer('openForm', true);
        });
    };

    stateCallback = (stateName, value, custom, translated, callback) => {
        this.setState({
            [stateName]: value?.target?.value ?? value
        }, callback);
    };

    initForm = () => {
        this.setState({
            editForm: 'add'
        })
        this.handleToggleDrawer('openForm');
    }

    editHandler = (product) => {
        this.setState({
            editForm: 'edit',
            currentCollectionId: product.id,
            collectionIdentifier: product.identifier
        })
        this.handleToggleDrawer('openForm');
    }

    getCollectionsCallback = () => {
        this.setState({
            reloadCollections: false
        })
    }
    reloadCollections = () => {
        this.setState({ reloadCollections: true })
    }

    componentDidMount() {
        checkRouting(this.props)
        // this.setUpAttributes();
        this.setState({
            isReady: true,
        });
        if (this.props.location.state?.hasMessage) {
            this.props.snack(ALERT_SUCCESS, this.props.location.state.message)
        }
    }

    render() {
        return (
            <div style={{ width: "100%", transition: 'all 250ms cubic-bezier(0, 0, 0.2, 1) 0ms' }}>
                <TopPanel
                    icomoon="picto-collections"
                    colorIcomoon={colors.blue.darker.hue300}
                    title={this.props.t('settings.collections.title')}
                    subtitle={this.props.t('settings.collections.subTitle')}
                    handlerAdd={() => this.initForm()}
                    textAdd={this.props.t('settings.collections.buttonadd')}
                    // searchHandler={
                    //     this.handleChangeCompanies
                    // } 
                    gradientColor1={colors.menu.regular}
                    gradientColor2={colors.menu.darker}
                    openForm={this.state.openForm}
                    buttonAvailable={!this.state.openForm}
                    // currentLang={this.state.currentLang} 
                    // handleLang={this.handleLang} 
                    // locales={this.props.locales}
                    // handlerImport={() => this.handleToggleDrawer('openImportTypesForm')} 
                    // textImport={"Importer des sociétés"}
                    hasBorder={true}
                />
                {/* <TraductionSelect 
                    currentLang={this.state.currentLang} 
                    handleLang={this.handleLang} 
                    locales={this.props.locales}
                /> */}
                <Grid container style={{ marginTop: 16 }}>
                    <Listing
                        label='collection'
                        settings={listSettings}
                        cardProps={{
                            openForm: this.state.openForm,
                            currentLang: this.state.currentLang,
                            textButton: this.props.t('settings.collections.buttonadd'),
                            handlerButton: this.editHandler,
                            windowWidth: this.props.windowWidth,
                        }}
                        perPageOptions={perPageOptions}
                        mappers={listMappers}
                        currentLang={this.state.currentLang}
                        identifier='selections'
                        viewsOptions={{
                            current: 'card',
                            settings: ['card'] //Si il n'y a qu'un seul item il n'y aura pas de changement de vues
                        }}
                        reload={this.state.reloadCollections}
                        listingCallback={this.getCollectionsCallback}
                    />
                </Grid>

                {this.state.isReady ? (
                    <div>
                        <LayoutBuilder
                            isSublayout={false}
                            icomoon="picto-collections"
                            opened={this.state.openForm}
                            forClose={() => this.handleToggleDrawer('openForm', true)}
                            handlerSetup={() => { }}
                            dataLayout={collectionEdit(this.state.currentLang, null, this.handleMediaPicker, this.state.editForm)}
                            drawerWidth={this.props.drawerWidth}
                            allState={this.state}
                            stateCallback={this.handleInput}
                            errorCallback={this.handleFormError}
                            stepperButtonAction={[
                                this.handleNextStep,
                                this.handleNextStep,
                                this.handleNextStep,
                            ]}
                            validateButton={true}
                            handlerMutation={this.handlerCollectionMutation}
                            currentLang={this.state.currentLang}
                            handleLang={this.handleLang}
                            deleteMutation={this.state.editForm === "edit" ? () => { this.handleToggleDialog() } : null}
                            deleteText={'Supprimer la collection'}
                        />
                    </div>
                )
                    : null}
                <Dialog
                    open={this.state.openDialog}
                    onClose={this.handleToggleDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Êtes-vous sûr de vouloir supprimer cette collection ?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Si vous supprimez cette collection, celle-ci ne sera plus accessible. Si vous ne souhaitez pas la supprimer, annulez la suppression en cliquant sur annuler.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleToggleDialog} color={colors.grey.regular} bgcolor={colors.white} bgcolorhover={colors.grey.lighter.hue900} border={`1px solid ${colors.grey.regular}`}>
                            Annuler
                        </Button>
                        <Button onClick={this.deleteMutation} bgcolor={colors.red.regular} bgcolorhover={colors.red.darker} autoFocus>
                            Supprimer
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    // be careful, only breaks references at objects level
    copyArrayOfObjects = array => array.map(a => a.node ? ({ ...a, node: { ...a.node } }) : ({ ...a }));

    goTo = route => {
        this.props.history.push(route);
    };
}

const mapStateToProps = state => {
    return {
        loading: state.loading,
        products: state.products,
        attributes: state.attributes,
        locales: state.locales
    };
};

const mapDispatchToProps = dispatch => {
    return {
        startLoading: () => dispatch({ type: START_LOADING }),
        stopLoading: () => dispatch({ type: STOP_LOADING }),
        snack: (type, message) => dispatch({ type: SNACK, payload: { type, message } })
    };
};

export default withTranslation()(withApollo(withRouter((connect(mapStateToProps, mapDispatchToProps)(ListCollections)))));